import { useSyncExternalStore } from 'react'
import { flagsDrawn } from '@/components/marketing/flag-support'

const neverChanges = () => () => {}

/**
 * A country flag, or nothing where the browser draws a flag as two letters (Windows). The server
 * render assumes a flag, and React reads the browser's answer after hydration, so they do not clash.
 */
export function Flag({ flag, className }: { flag?: string; className?: string }) {
  const drawn = useSyncExternalStore(neverChanges, flagsDrawn, () => true)
  if (!flag || !drawn) return null
  return <span aria-hidden="true" className={className}>{flag}</span>
}
